import React, { memo, useEffect, useRef } from 'react';
import { IBaseSection, IContent } from 'src/interface';
import { useIntersectionLoader } from 'src/hooks/useIntersectionLoader';
import { Element } from 'src/components';
import LoadMore from './LoadMore';
import styles from './styles.module.scss';

interface IProps extends IBaseSection<IContent> {
    className?: string;
    currentPage?: number;
    fetchFn: (...params: any) => Promise<any>;
    ComponentList: React.FunctionComponent<any>;
    ComponentEmpty?: React.FunctionComponent<any>;
    ComponentListProps: any;
    renderItemsFn?: (items: any[]) => any;
    showButtonLoadMore?: boolean;
}

export function InfiniteList(props: IProps) {
    const {
        className = '',
        fetchFn,
        items = [],
        ComponentEmpty,
        ComponentList,
        ComponentListProps,
        currentPage = 2,
        showButtonLoadMore = true,
    } = props;
    const firstRender = useRef(true);
    const [loaderRef, list, listAction] = useIntersectionLoader(
        fetchFn,
        {
            items: items,
            currentPage,
            isFetching: false,
        },
        {
            rootMargin: '300px',
        },
        currentPage,
    );

    useEffect(() => {
        if (!firstRender.current) {
            listAction.refresh({
                items: items,
                currentPage,
                isFetching: false,
            });
        }
        firstRender.current = false;
    }, [fetchFn]);

    const isEmpty = !list.isFetching && !list.items.length;

    if (isEmpty && !!ComponentEmpty) {
        return <ComponentEmpty />;
    }

    return (
        <Element className={className}>
            <ComponentList {...ComponentListProps} items={list.items} />
            <LoadMore
                startPage={currentPage}
                currentPage={list.currentPage}
                showButtonLoadMore={showButtonLoadMore}
                hasMore={list.hasMore || !isEmpty}
                isFetching={list.isFetching}
                loaderRef={loaderRef}
            />
            {!(list.currentPage === currentPage) && list.isFetching && (
                <Element className={styles['loading-content']}>
                    Đang tải tin ...
                </Element>
            )}
        </Element>
    );
}

export default memo(InfiniteList);
